import { ROUTES } from '@/Router'
import { useNavigate } from 'react-router-dom'

const useNavigateForm = () => {
  const navigate = useNavigate()

  const goToOffers = () => {
    navigate(ROUTES.offers)
  }

  const goToCheckout = () => {
    navigate(ROUTES.checkout)
  }

  const goToAditionalData = () => {
    navigate(ROUTES.aditionalData)
  }

  return {
    goToOffers,
    goToCheckout,
    goToAditionalData,
  }
}

export { useNavigateForm }
